import {Component, NgModule, OnDestroy, OnInit} from '@angular/core';
import {RouterModule} from '@angular/router';
import {HeaderComponent} from "./components/header/header.component";
import {ToastsComponentComponent} from "./components/toasts-component/toasts-component.component";
import {AsyncPipe, JsonPipe, NgIf} from '@angular/common';
import {AuthService} from "./services/auth-service.service";
import {OAuthErrorEvent, OAuthService} from "angular-oauth2-oidc";
import {Observable, Subscription} from "rxjs";
import { FormsModule, ReactiveFormsModule, FormGroup } from '@angular/forms';
import {BlockUIModule} from "ng-block-ui";
import {ToastService} from "./services/toast.service";

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [HeaderComponent, RouterModule, ToastsComponentComponent, NgIf, JsonPipe, AsyncPipe, ReactiveFormsModule, FormsModule, BlockUIModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnDestroy{
  title = 'Mortem-FE';
  s1:Subscription;
  constructor(
    public readonly authService: AuthService,
    private readonly oauthService: OAuthService,
    private ts:ToastService
  ) {
    this.s1 = this.oauthService.events.subscribe(event => {
      if (event instanceof OAuthErrorEvent && event.type === 'silent_refresh_timeout') {

        //FIXME: capire come reinizializzare la sessione in modalità silent
        console.error('Silent refresh error:', event);
        ts.showError("Attensione la sessione è scaduta");

        this.oauthService.silentRefresh().catch(error => {
          console.error('Silent refresh failed:', error);
          this.oauthService.initLoginFlow();
        })
      }
    });
  }

  ngOnDestroy(): void {
    if(this.s1)this.s1.unsubscribe();
  }
}
